import * as index from '@syncfusion/ej2-heatmap';
index.HeatMap.Inject( index.Legend,index.Tooltip,index.Adaptor);
export * from '@syncfusion/ej2-heatmap';
